module.exports = __webpack_public_path__ + "static/media/lowry.7ba94b50.jpg";